import React from 'react'

type Props = {
  children: React.ReactNode
}

export default function NavTooltip({ children }: Props) {
  return (
    <div
      className='px-2 py-1 bg-revamp-red-700 rounded-xl leading-none text-white'
      style={{ fontSize: '11px' }}
    >
      {children}
    </div>
  )
}
